import React from 'react'
import { useQuery } from '@tanstack/react-query'
import RewardsAPI from 'api/faber/RewardsAPI'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import format from 'date-fns/format'
import OrbitSession from 'hooks/useCookies'

import {
  CellText,
  fitTableHeight,
  listGridProps,
  MonoText,
  MutedText,
  StatusPill
} from './listUi'

const formatDate = (value?: string | number) =>
  value ? format(new Date(value), 'dd MMM yyyy, HH:mm') : '—'

const promocodeColumns = [
  {
    field: 'rewardName',
    headerName: 'Reward',
    sortable: false,
    flex: 1.6,
    minWidth: 220,
    renderCell: ({ row }) => <CellText strong>{row.rewardName}</CellText>
  },
  {
    field: 'promocode',
    headerName: 'Promocode',
    sortable: false,
    flex: 1,
    minWidth: 130,
    renderCell: ({ row }) => <MonoText>{row.promocode}</MonoText>
  },
  {
    field: 'promocodeType',
    headerName: 'Type',
    sortable: false,
    flex: 0.8,
    minWidth: 120,
    renderCell: ({ row }) => (
      <StatusPill status={row.promocodeType} tone='neutral' />
    )
  },
  {
    field: 'consumedAt',
    headerName: 'Redeemed',
    sortable: false,
    flex: 0.9,
    minWidth: 140,
    renderCell: ({ row }) =>
      row.consumedAt === 0 ? (
        <StatusPill status='AVAILABLE' />
      ) : (
        <MutedText>{formatDate(row.consumedAt)}</MutedText>
      )
  },
  {
    field: 'claimedAt',
    headerName: 'Claimed',
    sortable: false,
    flex: 0.9,
    minWidth: 140,
    renderCell: ({ row }) => <MutedText>{formatDate(row.claimedAt)}</MutedText>
  },
  {
    field: 'CreatedAt',
    headerName: 'Created',
    sortable: false,
    flex: 0.9,
    minWidth: 140,
    renderCell: ({ row }) => <MutedText>{formatDate(row.CreatedAt)}</MutedText>
  }
]

function PromocodesDisplayForOneUser({ userId }: { userId: string }) {
  const faberToken = OrbitSession.get('faberToken')

  const { data: allPromocodesData } = useQuery(
    ['get-all-promocodes-one-user', userId],
    async () => {
      return RewardsAPI.getAllPromocodesForOneUser({
        userId,
        faberToken
      })
    }
  )

  const rows = allPromocodesData ? allPromocodesData.body.data : []

  return (
    <MUIDataGrid
      {...listGridProps}
      columns={promocodeColumns}
      rows={rows}
      getRowId={(row) => row.ID}
      hideFooter
      tableHeight={fitTableHeight(rows.length)}
    />
  )
}

export default PromocodesDisplayForOneUser
